var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEngagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 13.5L24 6.75L15 0V4.5H3.75C2.50736 4.5 1.5 5.50736 1.5 6.75C1.5 7.99264 2.50736 9 3.75 9H15V13.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 19.5V24L0 17.25L9 10.5V15H20.25C21.4926 15 22.5 16.0074 22.5 17.25C22.5 18.4926 21.4926 19.5 20.25 19.5H9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEngagement);
export default __webpack_public_path__ + "static/media/icon-engagement.cab5bc474502ca8df63a04db71f7b4f0.svg";
export { ForwardRef as ReactComponent };